import React from "react";

import DownloadLink from "../../../components/common/DownloadLink";
import NonUnifiedTable from "./NonUnifiedTable";
import moment from "moment";

export default function NonUnifiedIndexes() {
  return (
    <div>
      <div className="d-flex justify-content-end mb-2">
        <DownloadLink
          variant="outline-primary"
          url="/projs/0/pcs/0/export"
          filename={`Неунифицированные показатели_${moment().format("DD.MM.yyyy")}.xlsx`}
        >
          Выгрузить в xls
        </DownloadLink>
      </div>
      <NonUnifiedTable />
    </div>
  );
}
